export const transactionTypes = {
  ORDER: "ORDER",
  ORDER_REFUND: "ORDER_REFUND",
  RECHARGE: "RECHARGE",
  RECHARGE_REFUND: "RECHARGE_REFUND",
  TOKEN: "TOKEN",
};
export const tokenTransactionTypes = {
  INCREMENTAL: "INCREMENTAL",
  DECREMENTAL: "DECREMENTAL",
};
export const itemEntities = {
  PRODUCT: "PRODUCT",
  DISCOUNT: "DISCOUNT",
  TIP: "TIP",
  TAX: "TAX",
};
export class Transaction {
  id = null;
  type = null;
  orderLines = null;
  tokenType = null;
  origin = null;
  moment = null;
  amount = 0;
  spentTokens = null;
  concept = null;
  reference = null;
  hasRefund = false;
  refunded = null;

  constructor(transaction, orderLines, token, spentTokens, context) {
    this.id = transaction.id;
    this.type = transactionTypes[transaction.type];
    this.order = transaction.order;
    this.origin = transaction.origin;
    this.moment = transaction.moment;
    this.amount = transaction.amount;
    this.concept = transaction.concept;
    this.hasRefund = transaction.has_refunds;
    if (this.hasRefund) {
      this.refunded = transaction.refunded_amount;
    }
    this.reference = transaction.reference;
    if (transaction.type === transactionTypes.TOKEN) {
      this.tokenType = tokenTransactionTypes[transaction.token_type];
      this.token = token;
      if (this.token == null) {
        this.token = {
          name: "ID " + transaction.token,
          icon: "local_play",
          id: transaction.token,
        };
      }
    }
    if (orderLines) {
      this.orderLines = orderLines;
      this.spentTokens = spentTokens;
    }
    this.name =
      context.$t(
        "transactions.transaction_types." +
          (transaction.type !== transactionTypes.TOKEN
            ? transaction.type
            : transaction.type + "_" + this.tokenType)
      ) +
      " " +
      (transaction.concept == "online"
        ? context.$t("transactions.transaction_types.ONLINE").toLowerCase() +
          (this.reference
            ? context.$t("transactions.with_reference." + this.reference)
            : "")
        : transaction.concept == '"CARD"'
        ? "con tarjeta"
        : transaction.concept == '"CASH"'
        ? "en efectivo"
        : "");
  }
}

export class OrderLine {
  id = null;
  orderId = null;
  product = null;
  paid = null;
  units = 0;
  attachment = null;

  constructor(orderLine, product) {
    this.id = orderLine.id;
    this.orderId = orderLine.order_id;
    this.product = product;
    if (this.product == null) {
      this.product = {
        name: "ID " + orderLine.product_id,
        icon: "stars",
        id: orderLine.product_id,
      };
    }
    this.paid = orderLine.paid;
    this.units = orderLine.units;
    this.attachment = orderLine.attachment;
  }
}

export class TokenTransaction {
  token = null;
  tokenType = null;
  served = null;
  orderId = null;
  orderRefundId = null;
  id = null;
  userId = null;
  deviceId = null;
  amount = null;
  moment = null;
  notified = null;
  origin = null;
  attachment = null;
  operator = null;
  reference = null;

  constructor(tokenTransaction, token) {
    this.token = token;
    if (this.token == null) {
      this.token = {
        name: "ID " + tokenTransaction.token,
        icon: "local_play",
        id: tokenTransaction.token,
      };
    }
    this.tokenType = tokenTransactionTypes[tokenTransaction.token_type];
    this.id = tokenTransaction.id;
    this.amount = tokenTransaction.amount;
  }
}
